import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Row, Col, Table, Button, Modal, ButtonGroup, Card } from 'react-bootstrap';
import { BiListOl, BiRefresh } from 'react-icons/bi';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import '../../../shared/Shared.css';
import $ from 'jquery';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert';
import { VedikaService } from '../../../services/VedikaService';
import LoadingSpinner from '../../../shared/LoadingSpinner';

const ResepElektronik = () => {
    const [listResepElektronik, setlistResepElektronik] = useState([]);
    const [selectedResepElektronik, setselectedResepElektronik] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const [showDeskripsi, setshowDeskripsi] = useState();
    const handleCloseDeskripsi = () => setshowDeskripsi(false);

    const loadInit = async () => {
        setIsLoading(true)
        try {
            const response = await VedikaService.getResepDokter(`noregistrasifk=${$('#norecPd').val()}`);
            setlistResepElektronik(response.data.data)
        } catch (error) {
            swal({
                title: error.code,
                text: error.message,
                icon: "error",
                button: "OK",
            })
                .then((val) => {
                });
        } finally {
            setIsLoading(false)
        }
    }
    
    const handleShowDeskripsi = (row) => {
        setIsLoading(true)
        setshowDeskripsi(true);
        setselectedResepElektronik(row)
        $('#dtResepElektronikDetail').DataTable().clear().draw();
        VedikaService.getDetailResepDokter(`strukorder=${row.norec}`)
            .then((res) => {
                loadDtResepElektronikDetail(res.data.data)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const loadDtResepElektronik = () => {
        $('#dtResepElektronik').DataTable({
            data: listResepElektronik,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            scrollY: '50vh',
            destroy: true,
            autoWidth: false,
            columns: [
                {
                    targets: [0],
                    data: null,
                    width:'10%',
                    createdCell: (td, cellData, rowData, row, col) => createRoot(td).render(<div className='d-flex justify-content-center'><ButtonGroup aria-label="Basic example"><Button size='sm' variant="dark" data-bs-toggle="tooltip" data-bs-placement="right" title='Resep Obat' onClick={() => handleShowDeskripsi(rowData)}><BiListOl /></Button></ButtonGroup></div>),
                },
                {
                    targets: [1],
                    data: 'tglorder',
                },
                {
                    targets: [2],
                    // data: 'namalengkap',
                    data:null,
                    createdCell:(td, cellData, rowData, row, col) => createRoot(td).render(<span>{ $('#dpjp').val()}</span>)
                },
            ]
        })
    }

    const loadDtResepElektronikDetail = (res) => {
        $('#dtResepElektronikDetail').DataTable({
            data: res,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            scrollY: '50vh',
            destroy: true,
            searching: false,
            bFilter: false,
            bLengthChange: false,
            columns: [
                {
                    targets: [0],
                    data: 'namaobat',
                },
                {
                    targets: [1],
                    data: 'keteranganpakai',
                },
                {
                    targets: [2],
                    data: 'keteranganlainnya',
                },
                {
                    targets: [3],
                    data: 'qtyproduk',
                },
            ]
        })
    }

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            borderColor: '#9e9e9e',
            minHeight: '30px',
            height: '30px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '30px',
            padding: '0 6px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '30px',
        }),
    };

    useEffect(() => {
        loadDtResepElektronik();
    }, [listResepElektronik])
    useEffect(() => {
        setTimeout(() => {
            loadInit()
        }, 1000);
    }, [])

    return (
        <React.Fragment>
            {isLoading ? (<LoadingSpinner />) : null}
            <Row>
                <Col md={10} className='text-center bg-success text-white'>
                    <h5>Resep Elektronik</h5>
                </Col>
                <Col className='d-flex justify-content-center bg-light'>
                    <div className="d-flex flex-row-reverse bd-highlight">
                        <Button size='sm' variant='light' onClick={loadInit}><BiRefresh /> Refresh</Button>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Table responsive="sm" size="sm" id='dtResepElektronik' bordered hover style={{ fontSize: 'smaller' }}>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Tanggal</th>
                                <th>DPJP</th>
                            </tr>
                        </thead>
                    </Table>
                </Col>
            </Row>
            <Modal
                show={showDeskripsi}
                onHide={handleCloseDeskripsi}
                backdrop="static"
                size='lg'
            >
                <Modal.Header closeButton>
                    <Modal.Title>Resep Obat</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Card>
                        <Card.Body>
                            {
                                selectedResepElektronik ? (
                                    <Row>
                                        <Col md={4}>
                                            <p className='f7'><strong>Tanggal</strong><br />{selectedResepElektronik.tglorder}</p>
                                        </Col>
                                        <Col md={4}>
                                            {/* <p className='f7'><strong>DPJP</strong><br />{selectedResepElektronik.namalengkap}</p> */}
                                            <p className='f7'><strong>DPJP</strong><br />{$('#dpjp').val()}</p>
                                        </Col>
                                    </Row>
                                )
                                    : null
                            }
                        </Card.Body>
                    </Card>
                    <Card className='mt-2'>
                        <Card.Body>
                            <Row>
                                <Col>
                                    <Table responsive="sm" size="sm" id='dtResepElektronikDetail' bordered hover style={{ fontSize: 'smaller' }}>
                                        <thead>
                                            <tr>
                                                <th>Nama Obat</th>
                                                <th>Keterangan pakai</th>
                                                <th>Keterangan Lainnya</th>
                                                <th>Qty</th>
                                            </tr>
                                        </thead>
                                    </Table>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default ResepElektronik;